import { useEffect as e, useMemo as t, useRef as n } from "react";
//#region src/hooks/useTimeout.ts
var r = (t, r) => {
	let i = n(null), a = n(t);
	return e(() => {
		a.current = t;
	}, [t]), e(() => {
		let e = () => a.current();
		if (typeof r == "number") return i.current = setTimeout(e, r), () => {
			i.current !== null && clearTimeout(i.current);
		};
	}, [r]), i;
}, i = () => {
	let r = 2 ** 31 - 1, i = (e, t, n) => {
		let a = n - Date.now();
		e.current = a <= r ? setTimeout(t, a) : setTimeout(() => i(e, t, n), r);
	}, a = n(null), { set: o, clear: s } = t(() => {
		let e = () => clearTimeout(a.current);
		return {
			set: (t, n = 0) => {
				e(), n <= r ? a.current = setTimeout(t, n) : i(a, t, Date.now() + n);
			},
			clear: e
		};
	}, []);
	return e(() => () => {
		s();
	}, [s]), {
		set: o,
		clear: s,
		handleRef: a
	};
};
//#endregion
export { r as default, i as useChainedTimeout };

//# sourceMappingURL=useTimeout.js.map